export default "__VITE_ASSET__CiERHNtA__"